<div class="container-fluid" [class.p-3]="!showImage()" [class.p-md-4]="!showImage()"
     [class.px-3]="showImage()" [class.px-md-4]="showImage()"
     [class.main-container-expanding-height]="showImage()">
  <div class="row align-items-stretch justify-content-center gap-3 gap-lg-0" [class.main-row-expanding-height]="showImage()">
    <div class="align-self-lg-start col-12"
         [class.col-md-7]="showImage()"
         [class.col-lg-6]="showImage()"
         [class.col-xl-5]="showImage()">
      <rf-page-title [title]="title()"/>

      @if (description(); as description) {
        <p class="pt-1">{{ description }}</p>
      }

      <form (ngSubmit)="submit()" class="mb-3 mt-4 mt-lg-5 needs-validation" #passwordForm="ngForm">
        <div [class.mb-3]="showEmail()" [class.d-none]="!showEmail()">
          <label for="email" class="form-label" i18n>Email</label>
          <input type="email" class="form-control" id="email" name="email"
                 [required]="showEmail()" [email]="showEmail()" autocomplete="username" [readonly]="!showEmail()"
                 [(ngModel)]="email" #emailField="ngModel"/>
          <rf-control-validation-errors [errors]="emailField.errors"/>
        </div>

        @if (formType() === PasswordFormType.Login) {
          <div class="mb-3">
            <label for="password" class="form-label" i18n>Password</label>
            <div class="input-group has-validation">
              <input [type]="showPassword() ? 'text' : 'password'" class="form-control" id="password" name="password"
                     required autocomplete="current-password"
                     [(ngModel)]="password" #passwordField="ngModel"/>
              <button type="button" class="btn btn-outline-secondary"
                      [class.active]="showPassword()"
                      [attr.aria-pressed]="showPassword()"
                      (click)="toggle(showPassword)">
                <i [rfBsIcon]="showPassword() ? 'eye-slash' : 'eye'"></i>
              </button>
              <rf-control-validation-errors [errors]="passwordField.errors"/>
            </div>
          </div>
        } @else if (showNewPasswordField()) {
          <div class="row">
            @if (formType() === PasswordFormType.ChangePassword) {
              <div class="mb-3 col-12 col-lg-4">
                <label for="oldPassword" class="form-label" i18n>Old password</label>
                <div class="input-group has-validation">
                  <input [type]="showPassword() ? 'text' : 'password'" class="form-control"
                         id="oldPassword" name="oldPassword" required autocomplete="current-password"
                         [(ngModel)]="password" #oldPasswordField="ngModel"/>
                  <button type="button" class="btn btn-outline-secondary"
                          [class.active]="showPassword()"
                          [attr.aria-pressed]="showPassword()"
                          (click)="toggle(showPassword)">
                    <i [rfBsIcon]="showPassword() ? 'eye-slash' : 'eye'"></i>
                  </button>
                  <rf-control-validation-errors [errors]="oldPasswordField.errors"/>
                </div>
              </div>
            }
            <div class="mb-3 col-12 col-lg-4">
              <label for="newPassword" class="form-label" i18n>New password</label>
              <div class="input-group has-validation">
                <!--suppress HtmlUnknownAttribute -->
                <input [type]="showNewPassword() ? 'text' : 'password'" class="form-control"
                       id="newPassword" name="newPassword"
                       required minlength="8" [pattern]="newPasswordPattern" rfValueNotEqual="oldPassword"
                       passwordrules="minlength: 8; required: lower; required: upper; required: digit; required: [!#$%&()*+,.:;<=>@\^_{}];"
                       autocomplete="new-password"
                       [(ngModel)]="newPassword" #newPasswordField="ngModel"/>
                <button type="button" class="btn btn-outline-secondary"
                        [class.active]="showNewPassword()"
                        [attr.aria-pressed]="showNewPassword()"
                        (click)="toggle(showNewPassword)">
                  <i [rfBsIcon]="showNewPassword() ? 'eye-slash' : 'eye'"></i>
                </button>
                <rf-control-validation-errors [errors]="newPasswordField.errors" [ignoredErrors]="['pattern']">
                  @if (newPasswordField.hasError('valueNotEqual')) {
                    <div i18n>New password must be different from the old password!</div>
                  }
                  @if (newPasswordField.hasError('pattern')) {
                    <div i18n>New password does not meet the complexity criteria!</div>
                  }
                </rf-control-validation-errors>
              </div>
            </div>
            <div class="mb-3 col-12 col-lg-4">
              <label for="repeatPassword" class="form-label" i18n>Repeat password</label>
              <div class="input-group has-validation">
                <input [type]="showRepeatPassword() ? 'text' : 'password'" class="form-control"
                       id="repeatPassword" name="repeatPassword"
                       required [rfValueEqual]="newPasswordField" autocomplete="new-password"
                       [(ngModel)]="repeatPassword" #repeatPasswordField="ngModel"/>
                <button type="button" class="btn btn-outline-secondary"
                        [class.active]="showRepeatPassword()"
                        [attr.aria-pressed]="showRepeatPassword()"
                        (click)="toggle(showRepeatPassword)">
                  <i [rfBsIcon]="showRepeatPassword() ? 'eye-slash' : 'eye'"></i>
                </button>
                <rf-control-validation-errors [errors]="repeatPasswordField.errors">
                  @if (repeatPasswordField.hasError('valueEqual')) {
                    <div i18n>Passwords does not match!</div>
                  }
                </rf-control-validation-errors>
              </div>
            </div>
          </div>
        }

        <div class="d-flex flex-wrap justify-content-between align-items-baseline gap-2">
          <button type="submit" class="btn btn-primary"
                  [rfLoadingIndicator]="isRequesting()"
                  [disabled]="passwordForm.invalid || isRequesting()">
            {{ buttonLabel() }}
          </button>

          @if (formType() === PasswordFormType.Login) {
            <a routerLink="/forgot-password" class="text-break" i18n>Forgot password</a>
          }
        </div>

        @if (showNewPasswordField()) {
          <div class="row mt-5">
            <h3 i18n>Complexity criteria</h3>
            <p i18n>
              Your password must not be the previous one, be at least 8 characters long and meet the following criteria.
            </p>
            <ul class="ps-5">
              <li i18n>At least one uppercase character</li>
              <li i18n>At least one lowercase character</li>
              <li i18n>At least one digit (0 - 9)</li>
              <li>
                <span i18n>At least one of the following special characters:</span><br/>
                {{ specialCharacters }}
              </li>
            </ul>
          </div>
        }
      </form>
    </div>

    @if (showImage()) {
      <div
        class="col-xl-7 col-lg-6 col-12 d-flex flex-column flex-fill justify-content-end align-items-center align-items-lg-start align-items-xl-center">
        <div class="me-lg-n4" style="overflow-x: clip;">
          <img ngSrc="assets/images/inspector-with-customers.svg" priority alt="Group of People (Users)" i18n-alt
               width="828" height="609" class="img-group"/>
        </div>
      </div>
    }
  </div>
</div>
